export const depositoNotaFiscalAnexoFilterConfig = [
  {
    id: 'Id',
    type: 'number',
    label: 'Id',
    placeholder: 'Id do anexo'
  },
  {
    id: 'UsuarioCriacao',
    type: 'text',
    label: 'Usuario',
    placeholder: 'Usuario de criacao'
  },
  {
    id: 'UrlAnexo',
    type: 'text',
    label: 'URL',
    placeholder: 'Trecho da URL'
  },
  {
    id: 'DataCriacaoInicio',
    type: 'date',
    label: 'Data Criacao (Inicio)'
  },
  {
    id: 'DataCriacaoFim',
    type: 'date',
    label: 'Data Criacao (Fim)'
  }
];
